import { Fetcher } from '@this/src/util';
import type { TravelRulesResponseArgs, TravelRules } from '../types/travelRules';

export const fetchTravelRules = async (): Promise<TravelRules> => {
  const response = await Fetcher.get<TravelRulesResponseArgs>('/trips/ai_messages/travel_rules');
  return convertToTravelRules(response);
};

const convertDeadlineInfo = (info: { business_days: number; hour: number; text: string }) => ({
  businessDays: info.business_days,
  hour: info.hour,
  text: info.text
});

const convertToTravelRules = (args: TravelRulesResponseArgs): TravelRules => ({
  hotelRules: {
    domesticPriceLimit: args.hotel_rules.domestic_price_limit,
    foreignPriceLimit: args.hotel_rules.foreign_price_limit,
    showOverLimit: args.hotel_rules.show_over_limit,
    showForeignOverLimit: args.hotel_rules.show_foreign_over_limit,
    allowBreakfastDomestic: args.hotel_rules.allow_breakfast_domestic,
    allowBreakfastForeign: args.hotel_rules.allow_breakfast_foreign
  },
  flightRules: {
    availableSeatClasses: args.flight_rules.available_seat_classes,
    allowSeatUpgrade: args.flight_rules.allow_seat_upgrade
  },
  shinkansenRules: {
    availableSeatTypes: args.shinkansen_rules.available_seat_types,
    showEx: args.shinkansen_rules.show_ex,
    useQr: args.shinkansen_rules.use_qr
  },
  deadlineRules: {
    hotel: convertDeadlineInfo(args.deadline_rules.hotel),
    domesticAir: convertDeadlineInfo(args.deadline_rules.domestic_air),
    shinkansen: convertDeadlineInfo(args.deadline_rules.shinkansen)
  },
  approvalRules: {
    domesticApprovalRequired: args.approval_rules.domestic_approval_required,
    foreignApprovalRequired: args.approval_rules.foreign_approval_required
  },
  organizationRules: {
    includeTax: args.organization_rules.include_tax
  },
  arrangementRequestRules: {
    enabled: args.arrangement_request_rules.enabled,
    fee: args.arrangement_request_rules.fee
  }
});
